import { api } from "./users";

export const getContrabusSalesReconciliation = async ({ year, month }) => {
  const response = await api.get("/network/reconciliation/", {
    params: { year, month },
  });
  return response.data;
};

export const downloadContrabusSalesReconciliationExcel = async ({
  year,
  month,
}) => {
  return api.get("/network/reconciliation/export/", {
    params: { year, month },
    responseType: "blob",
  });
};
